<template>
  <section class="document-section" v-if="$store.state.homeDocuments && $store.state.homeDocuments.length">
    <div class="document-section__container">
      <h2 class="document-section__title">Документы</h2>
      <ul class="document-section__row">
        <li class="document-section__column" v-for="(document, index) in $store.state.homeDocuments" :key="index">
          <router-link :to="{ name: 'documentsShow', params: { cat_id: document.category_id, id: document.id } }" class="document" :title="document.title" :aria-label="document.title">
            <i class="document__icon" aria-hidden="true">
              <document-icon/>
            </i>
            <time class="document__date" :datetime="document.date_publication | robotDate">{{ document.date_publication | humanDate }}</time>
            <p class="document__subtitle">{{ document.title }}</p>
          </router-link>
        </li>
      </ul>
      <router-link :to="{ name: 'documents' }" class="button-light" title="Все документы">Все документы</router-link>
    </div>
  </section>
</template>

<script>
import DocumentIcon from 'components/svg/DocumentIcon.vue'

export default {
  name: 'DocumentSection',
  components: { DocumentIcon }
}
</script>
